<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .dialler-avatar {
    align-items: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    position: relative;

    &.small {
      width: utils.in_rem(28px);
      height: utils.in_rem(28px);
      border-radius: utils.in_rem(8px);

      .initials {
        font-size: utils.in_rem(12px);
        letter-spacing: utils.in_rem(0.24px);
        line-height: utils.in_rem(18px);
      }
    }

    &.large {
      width: utils.in_rem(38px);
      height: utils.in_rem(38px);
      border-radius: utils.in_rem(10px);

      .initials {
        font-size: utils.in_rem(14px);
        letter-spacing: utils.in_rem(0.28px);
        line-height: utils.in_rem(20px);
      }
    }

    &.disabled {
      background-color: rgba(white, 0.15);
    }

    &.candidate {
      background-color: colors.get(activityClick_5);
      border: utils.in_rem(1px) solid rgba(white, 0.5);

      .initials {
        color: colors.get(activityClick_50);
      }
    }

    &.user,
    &.manager,
    &.teammate {
      background-color: colors.get(primary_5);
      border: none;

      .initials {
        color: colors.get(primary_50);
      }
    }

    &.teammate {
      background-color: colors.get(primary_5);
      border: none;

      .initials {
        color: colors.get(primary_50);
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .initials {
      font-family: "Lato", sans-serif;
      font-weight: 700;
      text-align: center;
    }

    .mode-icon {
      align-items: center;
      border: none;
      border-radius: utils.in_rem(40px);
      display: flex;
      height: utils.in_rem(14px);
      justify-content: center;
      left: utils.in_rem(18px);
      position: absolute;
      top: utils.in_rem(18px);
      width: utils.in_rem(14px);

      &.coaching {
        background-color: colors.get(primary_50);
        color: colors.get(textWhite);
      }

      &.participating {
        background-color: colors.get(accentStatusSeaGreen);
        color: colors.get(primary_80);
      }
    }
  }
</style>

<script>
  let {
    src = "",
    firstName = "",
    lastName = "",
    size = "large",
    state = "default",
    alt = "Contact",
    modeIcon = null, // 'coaching' | 'participating' | null
    initialsVisible = false,
  } = $props();

  const initials = $derived(
    `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`
  );

  const handleImageError = (el) => {
    if (el && el.target) {
      el.target.style.display = "none";
    }
  };
</script>

<div class="dialler-avatar {size} {state}">
  {#if src}
    <img {src} {alt} onerror={handleImageError} />
    {#if !src || src === ""}
      {#if initialsVisible}
        <span class="initials">{initials}</span>
      {/if}
    {/if}
  {:else if initialsVisible}
    <span class="initials">{initials}</span>
  {:else}
    <span class="initials"><i class="fa-solid fa-user"></i></span>
  {/if}

  {#if modeIcon}
    <div class="mode-icon {modeIcon}">
      <i
        class="fa-solid {modeIcon === 'coaching'
          ? 'fa-headphones'
          : 'fa-microphone-stand'}"
        size="xxs"
      >
      </i>
    </div>
  {/if}
</div>
